import React, { useState, useContext, useRef } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { apiUrl } from '../constant';
import { userService } from '../services/authentication';
import { timesheetService } from '../services/timesheetService';
// import { ToastContainer, toast } from 'react-toastify';
import MyContext from "../contextapi/MyContext";
import logo from '../assets/images/businessbackground.jpg';
import '../assets/css/login.css';
import { Toast } from 'primereact/toast';
import Smallloader, { Smallloadertrans } from '../compnents/loader';

const Forgotpassword = () => {
    const toast = useRef(null);
    const mycontext = useContext(MyContext);
    const axios = require("axios");
    const history = useNavigate();

    const [inputFielduEmail, setInputuemail] = useState({
        email: "",
    });

    const [inputFieldEmail, setInputemail] = useState({
        newpassword: "",
    });

    const [inputFieldpass, setInputpassword] = useState({
        repeatpassword: "",
    });
    const [errors, setErrors] = useState({});
    


    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (inputFielduEmail.email == '') {
            newErrors.email = 'Field is required';
            valid = false;
        }

        if (inputFieldEmail.newpassword == '') {
            newErrors.newpassword = 'Field is required';
            valid = false;
        }

        if (inputFieldEmail.newpassword.length <= 4) {
            newErrors.newpassword = 'Weak password';
            valid = false;
        }

        if (inputFieldpass.repeatpassword == '') {
            newErrors.repeatpassword = 'Field is required';
            valid = false;
        }


        if (inputFieldpass.repeatpassword != inputFieldEmail.newpassword) {
            newErrors.notmatched = 'Password Not Matched';
            valid = false;
        }
        setErrors(newErrors);

        return valid;
    }


    const resetpass__ = (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }

       

        var newpass = inputFieldEmail.newpassword;
        var repeatpass = inputFieldpass.repeatpassword;
        var email = inputFielduEmail.email;
        
        
        // setloggin(false);
        let obj = { 'email': email, 'newpass': newpass, 'repeatpass': repeatpass };
        
        
        timesheetService.forgotpassword__(obj).then((response) => {
               console.log(response);
               if(response == undefined){
                return;
            }
            if(response.status == 200){
               toast.current.show({severity:'success', summary: "ForgotPassword update", detail:`Updated successfully`, life: 3000}); 
               history('/'); 
            //    setTimeout(()=>{
                 
            //    },5000);
               
             }else{
                toast.current.show({severity:'error', summary: "ForgotPassword update", detail:`Not Updated`, life: 3000});
             // toast.error("Authenticate");
            }
            
        }).catch((error) => {
           
        });
    }

    const inputsHandleremail = (e) => {
        setInputemail({ [e.target.name]: e.target.value });
    };

    const inputsHandlerpass = (e) => {
        setInputpassword({ [e.target.name]: e.target.value });
    };

    return (
        <>
            <div style={{display:'flex',justifyContent: 'center',height:'100vh',alignItems: 'center'}}>
                <Toast ref={toast} />
                <br />
                <div className="login-container">

                    <form role="form" onSubmit={(e)=>resetpass__(e)}>

                        <div className="form-group">
                            <label htmlFor="exampleInputEmail12" className="login-label">Username or Email</label>
                            <input type="text" name="email" className="form-control" id="exampleInputEmail12" aria-describedby="emailHelp" placeholder="Username or Email"
                                onChange={(e) => setInputuemail({'email':e.target.value})}
                                required />

                            {errors.email && <span className='error'>{errors.email}</span>}
                            {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                        </div>
                        <br></br>

                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1" className="login-label">New password</label>
                            <input type="password" name="newpassword" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Password"
                                onChange={inputsHandleremail}
                                required />

                            {errors.newpassword && <span className='error'>{errors.newpassword}</span>}
                            {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                        </div>
                        <br></br>
                        <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="login-label">Repeat Password</label>
                            <input type="password" name="repeatpassword" className="form-control" id="exampleInputPassword1" placeholder="Password" onChange={inputsHandlerpass}
                                required />
                            {errors.repeatpassword && <span className='error'>{errors.repeatpassword}</span>}
                        </div>
                        <div className="form-check">
                            {/* <input type="checkbox" className="form-check-input" id="exampleCheck1"/>
                        <label className="form-check-label" for="exampleCheck1">Check me out</label> */}
                        </div>
                        {errors.notmatched && <span className='error'>{errors.notmatched}</span>}
                        <br />

                        <button type="submit"  className="btn btn-primary">Change password </button>
                    </form>
                </div>
                <div style={{position: 'absolute',
    color: 'white',
    bottom: '14px',
}}>CopyRight © Corient Business Solutions | 2024</div>
            </div>
        </>
    );
}

export default Forgotpassword;